import Text from '@/components/common/Text';
import Icon from '@/components/common/Icon';

const SelectedItem = ({ item, onFilterChange, filterKey, multiple }) => {
    return (
        <div className='selected-block'>
            <Text className={'h4 font-futura-regular black'}>{item.name}</Text>
            <Icon
                name={'close'}
                onClick={() => onFilterChange(filterKey, item.id, multiple)}
                className={'selected-item-close green h6'}
            />
        </div>
    )
}

export default SelectedItem